import { GraphQLInputObjectType, GraphQLString, GraphQLList } from 'graphql'

export interface LibraryFilterArg {
  readonly servers?: string[]
  readonly languages?: string[]
  readonly tags?: string[]
  readonly grades?: string[]
  readonly applications?: string[]
  readonly environments?: string[]
  readonly licenses?: string[]
  readonly filterText?: string
  readonly quickFilter?: string
  readonly status?: string
  readonly usage?: string[]
}

const filterList = new GraphQLList(GraphQLString)

export const libraryFilterArgType = new GraphQLInputObjectType({
  name: 'LibraryFilterArg',
  description:
    'A collection of criteria categories and values to filter the libraries by. Each criteria category consists of a list of strings. Categories of criteria are applied with an AND relationship. Within each category, the individual criteria values are applied with an OR relationaship',
  fields: () => ({
    servers: {
      description: 'Filters by servers',
      type: filterList
    },
    languages: {
      description: 'Filters by language',
      type: filterList
    },
    tags: {
      description: 'Filters by tags',
      type: filterList
    },
    applications: {
      description: 'Filters by applications',
      type: filterList
    },
    environments: {
      description: 'Filters by environments',
      type: filterList
    },
    grades: {
      description: 'Filters by grades',
      type: filterList
    },
    licenses: {
      description: 'Filters by licenses',
      type: filterList
    },
    filterText: {
      description: 'Filter libraries that match the specified text string',
      type: GraphQLString
    },
    quickFilter: {
      description: 'An optional predefined filter',
      type: GraphQLString
    },
    status: {
      description: 'An optional library status to filter by',
      type: GraphQLString
    },
    usage: {
      description: 'Filter libraries by usage',
      type: filterList
    }
  })
})
